// action - state management
import { REGISTER, LOGIN, LOGOUT, UPDATE_AUTH_USER } from "./actions";

// initial state
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  authUser: null,
};

// ==============================|| AUTH REDUCER ||============================== //

export default (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user,
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
      };
    }
    case UPDATE_AUTH_USER: {
      return {
        ...state,
        authUser: action.payload,
        loadUser: true,
      };
    }
    default: {
      return { ...state };
    }
  }
};

// export default auth;
